import { styled } from '@mui/material';
import PerfectScrollbar from 'components/SafePerfectScrollbar';

export const StyledPerfectScrollbar = styled(PerfectScrollbar)({
  overflowY: 'auto', height: '50rem', marginTop: '1rem', overflowX: 'hidden'
});